"use strict";

const React = require('react');
const PropTypes = require('prop-types');
const UserStore = require('../../../global/stores/UserStore.es');
const makeOfferLauncher = require('../../../contact/offer/helpers/MakeOfferLauncher');
const ArrowRightIcon = require('dibs-vg/dist/react/arrow-right');
const PurchaseTracking = require('../../../global/mixins/purchaseTracking');
const classNames = require('classnames');
const css = require('../ItemActionButtons-style.scss');
const get = require('lodash.get');
const copy = require('../../../../../json/copy/itemActionButtons.json');

class MakeOfferButton extends React.Component {
    constructor(props) {
        super(props);
        this.onMakeOffer = this.onMakeOffer.bind(this);
        if (props.tracking) {
            this.purchaseTracking = new PurchaseTracking({
                item: props.item,
                pageContext: props.tracking.pageContext
            });
            this.purchaseTracking.url = props.tracking.url || document.URL;
        }
    }

    onMakeOffer() {
        const currency = this.props.context.getStore(UserStore).getCurrency();

        makeOfferLauncher(Object.assign({
            currency,
            purchaseTracking: this.purchaseTracking,
            linkLocation: get(this.props.tracking, 'pageContext')
        }, this.props));

        if (this.purchaseTracking) {
            this.purchaseTracking.ecommerceAddToCartTracking({
                url: this.purchaseTracking.url,
                isTrade: this.props.enableRequestNetPrice
            });
            this.purchaseTracking.trackOfferEvent({
                actionPrefix: 'offer selected',
                actionSuffix: 'make offer button',
                objectName: 'button'
            });
        }
    }

    render() {
        const {buttonClass, makeOfferPurchaseSwapTestRunning = false} = this.props;
        const showArrow = (!buttonClass || buttonClass === 'button-large') && !makeOfferPurchaseSwapTestRunning;
        const cls = classNames(
            'button',
            `button-${makeOfferPurchaseSwapTestRunning ? 'primary' : 'secondary'}`,
            buttonClass,
            { 'button-large': !buttonClass }
        );
        let arrow;
        if (showArrow) {
            arrow = <ArrowRightIcon className={css.itemActionRightArrow} />;
        }
        return (
            <button className={cls} data-tn="item-actions-make-offer" onClick={this.onMakeOffer}>
                {copy.makeOffer}
                {arrow}
            </button>
        );
    }
}

MakeOfferButton.propTypes = {
    buttonClass: PropTypes.string,
    tracking: PropTypes.object,
    item: PropTypes.object.isRequired,
    transaction: PropTypes.object,
    enableRequestNetPrice: PropTypes.bool,
    context: PropTypes.object,
    makeOfferPurchaseSwapTestRunning: PropTypes.bool
};

module.exports = MakeOfferButton;



// WEBPACK FOOTER //
// ./assets/js/components/ItemActionButtons/MakeOfferButton/MakeOfferButton.jsx